<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
//eslint-disable-next-line
import CertificateAuthentication from "../../../../src/components/certificate-authentication/certificateAuthentication.vue";
/**
 * Starter component
 */
export default {
    page: {
        title: "Collections List",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader, CertificateAuthentication },
    data() {
        return {
            title: "Certificate Authentication",
            items: [
                // {
                //     text: "Clients",
                //     href: "/clients",
                // },
            ],
        };
    },
    mounted() {},
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <CertificateAuthentication />
    </Layout>
</template>
